import { isInProgress, isPending } from "App/apiMiddleware";
import { getActiveDocumentId, getActiveDocumentType } from "Areas/Sidebar/Documents/redux/getActiveDocumentId";
import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export { getActiveDocumentId };
export const getInnerObjectsSelectedIds = createSelector((state) => getActiveDocumentId(state), (state) => getActiveDocumentType(state), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].innerObjectsSelectedIds`), (activeDocumentId, activeDocumentType, innerObjectsSelectedIds) => activeDocumentId &&
    activeDocumentType &&
    innerObjectsSelectedIds &&
    innerObjectsSelectedIds[activeDocumentId] &&
    innerObjectsSelectedIds[activeDocumentId][activeDocumentType]
    ? innerObjectsSelectedIds[activeDocumentId][activeDocumentType]
    : []);
export const getTaskResultLimitByDocumentId = createSelector((state, documentId) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].taskResultLimit[${documentId}]`), (taskResultLimit) => taskResultLimit);
export const getTaskResultLimit = createSelector((state) => getTaskResultLimitByDocumentId(state, getActiveDocumentId(state)), (taskResultLimit) => taskResultLimit);
export const getTaskResultLimitInProgress = (state) => isPending(state, `${actionTypes.GET_TASK_RESULT_LIMIT}_${getActiveDocumentId(state)}`) ||
    isInProgress(state, `${actionTypes.SAVE_TASK_RESULT_LIMIT}_${getActiveDocumentId(state)}`);
